module.exports = __webpack_public_path__ + "static/media/A18040103_10002_3.2b1558f5.jpg";